import { render } from "./ListSizeRenderer.vue?vue&type=template&id=188c2469"
import script from "./ListSizeRenderer.vue?vue&type=script&lang=js"
export * from "./ListSizeRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__